import {Handler, HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {findUniqueChannelType} from '../../../helpers/models/channelHelpers';
import {ChannelModel} from '../../../models/api/channelModel';
import {InboxModel} from '../../../models/api/inboxModel';
import {RuleBundleModel, RuleBundleModelStrict} from '../../../models/api/ruleBundleModel';
import {CompoundConditions} from '../../editors/conditions/compoundConditionModel';
import {RuleAction} from '../../rules/ruleActionModel';
import {ImpactedInboxes} from '../../rules/ruleSimulationHelpers';

export const NODE_WIDTH = 200;
export const MAIN_INBOX_NODE_HEIGHT = 102;
export const INBOX_NODE_HEIGHT = 86;
export const BUNDLE_NODE_HEIGHT = 32;

export interface InboxGraphInheritableProps {
  listImpactedInboxes: (compoundConditions: CompoundConditions) => ImpactedInboxes;
  getFedInbox: (actions: ReadonlyArray<RuleAction>) => InboxModel | undefined;
  goToChannel: HandlerOf<{channelId: number; inboxId?: number}>;
  goToInboxRules: Handler;
  goToInbox: HandlerOf<number>;
  getInboxById: (id: number) => InboxModel | undefined;
  goToBundle: HandlerOf<RuleBundleModel>;
  /** Channels feeding the inbox with conversations. */
  channels: ReadonlyArray<ChannelModel>;
  getUniqueChannelType: (channel: ChannelModel) => ReturnType<typeof findUniqueChannelType>;
}

export interface InboxGraphProps extends InboxGraphInheritableProps {
  /** Inbox represented in the graph. */
  inbox: InboxModel;
  /** Bundles feeding the inbox with conversations. */
  moveInBundles: ReadonlyArray<RuleBundleModelStrict>;
  /** Bundles emptying the inbox of conversations. */
  moveOutBundles: ReadonlyArray<RuleBundleModelStrict>;
}

export interface InboxGraphNodeBase {
  id: string;
  label: string;
  x: number;
  y: number;
}

export enum InboxGraphNodeTypesEnum {
  CHANNEL = 'channel',
  ANY_INBOX = 'any_inbox',
  MAIN_INBOX = 'main_inbox',
  INBOX = 'inbox',
  BUNDLES = 'bundles',
}

export interface InboxGraphChannelNode extends InboxGraphNodeBase {
  type: InboxGraphNodeTypesEnum.CHANNEL;
  uniqueChannelType: ReturnType<typeof findUniqueChannelType>;
  onClick: () => void;
}

export interface InboxGraphInboxNode extends InboxGraphNodeBase {
  type: InboxGraphNodeTypesEnum.INBOX;
  iconColor?: string;
  onClick?: () => void;
}

export interface InboxGraphMainInboxNode extends InboxGraphNodeBase {
  type: InboxGraphNodeTypesEnum.MAIN_INBOX;
  iconColor: string;
}

export interface InboxGraphAnyInboxNode extends InboxGraphNodeBase {
  type: InboxGraphNodeTypesEnum.ANY_INBOX;
}

export interface InboxGraphBundlesNode extends InboxGraphNodeBase {
  type: InboxGraphNodeTypesEnum.BUNDLES;
  bundles: ReadonlyArray<RuleBundleModel>;
  onClick: (id: RuleBundleModel | undefined) => void;
}

export type InboxGraphNode =
  | InboxGraphChannelNode
  | InboxGraphInboxNode
  | InboxGraphMainInboxNode
  | InboxGraphAnyInboxNode
  | InboxGraphBundlesNode;

export interface InboxGraphLink {
  source: InboxGraphNode;
  target: InboxGraphNode;
}
